import * as React from 'react';
import * as ToastPrimitive from '@radix-ui/react-toast';
import { cn } from '@/lib/utils';

/* shadcn/ui Toast (Radix: announced politely to screen readers, F8 focuses the viewport), styled as the reference's .toast. */
export const ToastProvider = ToastPrimitive.Provider;

export const ToastViewport = React.forwardRef<
  React.ElementRef<typeof ToastPrimitive.Viewport>,
  React.ComponentPropsWithoutRef<typeof ToastPrimitive.Viewport>
>(({ className, ...props }, ref) => (
  <ToastPrimitive.Viewport
    ref={ref}
    className={cn('fixed left-1/2 z-[70] m-0 flex w-[min(92vw,440px)] -translate-x-1/2 list-none flex-col gap-2 p-0 outline-none', className)}
    style={{ bottom: 'calc(24px + env(safe-area-inset-bottom, 0px))' }}
    {...props}
  />
));
ToastViewport.displayName = 'ToastViewport';

export const Toast = React.forwardRef<React.ElementRef<typeof ToastPrimitive.Root>, React.ComponentPropsWithoutRef<typeof ToastPrimitive.Root>>(
  ({ className, ...props }, ref) => (
    <ToastPrimitive.Root
      ref={ref}
      className={cn('rounded-xl px-[18px] py-3 font-semibold shadow-lg', className)}
      style={{ background: 'var(--text)', color: 'var(--bg)' }}
      {...props}
    />
  ),
);
Toast.displayName = 'Toast';

export const ToastTitle = ToastPrimitive.Title;
export const ToastDescription = ToastPrimitive.Description;
export const ToastClose = ToastPrimitive.Close;
